import { iTradeEnv } from "@/configurations/app-configs/iTrade.env";
import { isDevelopment, isProduction } from "@/helpers/global/env.func";
import { getDecryptData } from "@/helpers/global/decrypt";

const mockMdsInfo = null;

const mdsInfo = (() => {
  if (isDevelopment() && mockMdsInfo && !Array.isArray(mockMdsInfo) && typeof mockMdsInfo === 'object') {
    return mockMdsInfo;
  }

  if (typeof window.config?.mdsInfo === 'string' && window.config?.mdsInfo.trim()) {
    try {
      const data = JSON.parse(getDecryptData(process.env.SECRET_KEY, window.config?.mdsInfo))
      return data;
    } catch (e) {
      return {};
    }
  }

  return window.config?.mdsInfo || {};
})();

export const appConfigConstants = {
  itradeAPI: isProduction() && window.config?.itradeAPI || iTradeEnv?.constants.apiEnv?.itradeAPI || '',
  itradePath: isProduction() && window.config?.itradePath || iTradeEnv?.constants.apiEnv?.itradePath || 'api',

  MDSStreamingAPI: mdsInfo?.MDSStreamingAPI,
  MDSSnapshotAPI: mdsInfo?.MDSSnapshotAPI,
  MDSOthersAPI: mdsInfo?.MDSOthersAPI,
  MDS9997API: mdsInfo?.MDS9997API,
  MDSProxyAPI: mdsInfo?.MDSProxyAPI,

  MDSEntityKey: mdsInfo?.MDSEntityKey,
  MDSSuperkey: mdsInfo?.MDSSuperkey,

  winvestorAPI: isProduction() && window.config?.winvestorAPI || iTradeEnv?.constants.apiEnv?.winvestorAPI || '',
  winvestorPath: isProduction() && window.config?.winvestorPath || iTradeEnv?.constants.apiEnv?.winvestorPath || 'ib/api',

  winvestorDeviceID: isProduction() && window.config?.winvestorDeviceID || iTradeEnv?.constants.winVest?.winvestorDeviceID || '',

  exportExeclFile: isProduction() && window.config?.exportExeclFile === 'true' || iTradeEnv?.constants?.exportExeclFile === 'true' || false,

  portfolioRefreshAfterParaChangeMs: isProduction() && window.config?.portfolioRefreshAfterParaChangeMs || iTradeEnv?.constants?.apiEnv?.portfolioRefreshAfterParaChangeMs || 2000,
  portfolioRefreshAfterParaChangeAttempts: isProduction() && window.config?.portfolioRefreshAfterParaChangeAttempts || iTradeEnv?.constants?.apiEnv?.portfolioRefreshAfterParaChangeAttempts || 1,

  popupIPRestrictedMsg: isProduction() && window.config?.popupIPRestrictedMsg || iTradeEnv?.constants?.apiEnv?.popupIPRestrictedMsg || false,
}